import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BRAND } from "@/lib/constants";

export const LoadingScreen = ({ onFinish }) => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => {
      setShow(false);
      onFinish && onFinish();
    }, 1200);
    return () => clearTimeout(t);
  }, [onFinish]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="loading-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[100] bg-[#050B14] grid place-items-center"
        >
          <div className="flex flex-col items-center gap-6">
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
            >
              <div className="absolute -inset-6 bg-[radial-gradient(closest-side,rgba(212,175,55,0.35),transparent)] blur-2xl" />
              <img src={BRAND.logo} alt="VR Marketing Hub" className="relative w-24 h-24 rounded-full ring-1 ring-[#D4AF37]/50" />
            </motion.div>
            <div className="text-center">
              <div className="text-white font-bold tracking-tight">VR Marketing Hub</div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37] mt-1">Growth · Leads · Results</div>
            </div>
            <div className="w-40 h-[3px] bg-white/10 rounded-full overflow-hidden">
              <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: "100%" }}
                transition={{ duration: 1.1, ease: "easeInOut" }}
                className="h-full w-1/2 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
